export default ["#e23939", "#ee9339", "#f1c338", "#61c33d", "#49a8f0", "#c26ada", "#000000", "#939396"]
